import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IReportsRefferalCustomer_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsRefferalCustomer_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  KuikaB2B_ShipmentSalesCustomerMobile: any[];
  KuikaB2B_ShipmentSalesCustomerMobile_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp409247Visible: "visible" | "hidden";
}

export class ReportsRefferalCustomer_ScreenBase extends React.PureComponent<
  IReportsRefferalCustomer_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  reportsrefferalcustomer_373528_value_kuikaSelectBoxRef: React.RefObject<any>;
  reportsrefferalcustomer_330953_value_kuikaDateRef: React.RefObject<any>;
  reportsrefferalcustomer_179452_value_kuikaDateRef: React.RefObject<any>;
  reportsrefferalcustomer_624937_value_kuikaTableRef: React.RefObject<any>;
  reportsrefferalcustomer_362270_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 654370,
          PropertyName: "value",
          Value: "Sevk Raporu",
          TagName: "Label5_value",
        },
        {
          Id: 555464,
          PropertyName: "value",
          Value: "Tarih Filtresi",
          TagName: "Label6_value",
        },
        {
          Id: 373528,
          PropertyName: "placeholder",
          Value: "Tarih Aralığı",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 179452,
          PropertyName: "placeholder",
          Value: "Bitiş Tarihi...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 518571,
          PropertyName: "label",
          Value: "Temizle",
          TagName: "Button2_label",
        },
        {
          Id: 595833,
          PropertyName: "label",
          Value: "Uygula",
          TagName: "Button1_label",
        },
        {
          Id: 330953,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 107900,
          PropertyName: "value",
          Value: "Müşteri Kodu",
          TagName: "Label9_value",
        },
        {
          Id: 931071,
          PropertyName: "value",
          Value: "Müşteri Unvanı",
          TagName: "Label11_value",
        },
        {
          Id: 974894,
          PropertyName: "value",
          Value: "Miktar",
          TagName: "Label13_value",
        },
        {
          Id: 10427,
          PropertyName: "value",
          Value: "Metrekare",
          TagName: "Label15_value",
        },
        {
          Id: 859206,
          PropertyName: "value",
          Value: "Sevk Bekleyen Miktar",
          TagName: "Label21_value",
        },
        {
          Id: 884902,
          PropertyName: "value",
          Value: "Sevk Bekleyen Metrekare",
          TagName: "Label23_value",
        },
        {
          Id: 806590,
          PropertyName: "value",
          Value: "Sevk Edilen Miktar",
          TagName: "Label25_value",
        },
        {
          Id: 475970,
          PropertyName: "value",
          Value: "Sevk Edilen Metrekare",
          TagName: "Label27_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 654370,
          PropertyName: "value",
          Value: "Dispatch Report",
          TagName: "Label5_value",
        },
        {
          Id: 555464,
          PropertyName: "value",
          Value: " Date Filter",
          TagName: "Label6_value",
        },
        {
          Id: 373528,
          PropertyName: "placeholder",
          Value: "Date Range",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 179452,
          PropertyName: "placeholder",
          Value: "End Date...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 518571,
          PropertyName: "label",
          Value: "Clear",
          TagName: "Button2_label",
        },
        {
          Id: 595833,
          PropertyName: "label",
          Value: "Apply",
          TagName: "Button1_label",
        },
        {
          Id: 330953,
          PropertyName: "placeholder",
          Value: "Start Date...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 107900,
          PropertyName: "value",
          Value: "Customer Code",
          TagName: "Label9_value",
        },
        {
          Id: 931071,
          PropertyName: "value",
          Value: "Customer Title",
          TagName: "Label11_value",
        },
        {
          Id: 974894,
          PropertyName: "value",
          Value: "Quantity",
          TagName: "Label13_value",
        },
        {
          Id: 10427,
          PropertyName: "value",
          Value: "Square meters",
          TagName: "Label15_value",
        },
        {
          Id: 859206,
          PropertyName: "value",
          Value: "Quantity Pending Shipment",
          TagName: "Label21_value",
        },
        {
          Id: 884902,
          PropertyName: "value",
          Value: "Square Meters Pending Shipment",
          TagName: "Label23_value",
        },
        {
          Id: 806590,
          PropertyName: "value",
          Value: "Quantity Shipped",
          TagName: "Label25_value",
        },
        {
          Id: 475970,
          PropertyName: "value",
          Value: "Square Meters Shipped",
          TagName: "Label27_value",
        },
      ],
    },
    {
      Id: "c973485f-27ea-4739-abe9-84d537e3601c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 654370, PropertyName: "value", Value: "Sevk Raporu" },
        { Id: 555464, PropertyName: "value", Value: "Tarih Filtresi" },
        { Id: 373528, PropertyName: "placeholder", Value: "Tarih Aralığı" },
        {
          Id: 330953,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
        },
        { Id: 179452, PropertyName: "placeholder", Value: "Bitiş Tarihi..." },
        { Id: 518571, PropertyName: "label", Value: "Temizle" },
        { Id: 595833, PropertyName: "label", Value: "Uygula" },
        { Id: 249813, PropertyName: "title", Value: "Title" },
        { Id: 107900, PropertyName: "value", Value: "Müşteri Kodu" },
        {
          Id: 298883,
          PropertyName: "value",
          Value: "[datafield:customercode]",
        },
        { Id: 931071, PropertyName: "value", Value: "Müşteri Unvanı" },
        {
          Id: 495593,
          PropertyName: "value",
          Value: "[datafield:customerdescription]",
        },
        { Id: 974894, PropertyName: "value", Value: "Miktar" },
        { Id: 416078, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 10427, PropertyName: "value", Value: "Metrekare" },
        { Id: 631919, PropertyName: "value", Value: "[datafield:qty2]" },
        { Id: 859206, PropertyName: "value", Value: "Sevk Bekleyen Miktar" },
        { Id: 709916, PropertyName: "value", Value: "[datafield:returnqty1]" },
        { Id: 884902, PropertyName: "value", Value: "Sevk Bekleyen Metrekare" },
        { Id: 185965, PropertyName: "value", Value: "[datafield:returnqty2]" },
        { Id: 806590, PropertyName: "value", Value: "Sevk Edilen Miktar" },
        { Id: 546919, PropertyName: "value", Value: "[datafield:netqty1]" },
        { Id: 475970, PropertyName: "value", Value: "Sevk Edilen Metrekare" },
        { Id: 814316, PropertyName: "value", Value: "[datafield:netqty2]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.reportsrefferalcustomer_373528_value_kuikaSelectBoxRef =
      React.createRef();
    this.reportsrefferalcustomer_330953_value_kuikaDateRef = React.createRef();
    this.reportsrefferalcustomer_179452_value_kuikaDateRef = React.createRef();
    this.reportsrefferalcustomer_624937_value_kuikaTableRef = React.createRef();
    this.reportsrefferalcustomer_362270_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      B2BGetRolesById: [],
      KuikaB2B_ShipmentSalesCustomerMobile: [],
      SetValueOf: "",
      NAVIGATE: "",
      dataSource_373528: [
        { key: "10", text: "İki Tarih Arası Filtreleme" },
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      isComp409247Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportsrefferalcustomer",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ReportsRefferalCustomerPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ReportsRefferalCustomerPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsrefferalcustomer",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsrefferalcustomer",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsRefferalCustomerPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ReportsRefferalCustomerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsRefferalCustomerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      startDate_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      pageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsRefferalCustomer/ReportsRefferalCustomerPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    stateVars.KuikaB2B_ShipmentSalesCustomerMobile =
      result?.data.kuikaB2B_ShipmentSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ReportsRefferalCustomerPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsRefferalCustomerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp409247Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_ShipmentSalesCustomerMobile ??
      this.state.KuikaB2B_ShipmentSalesCustomerMobile;
    formVars.reportsrefferalcustomer_362270_total = ReactSystemFunctions.value(
      this,
      stateVars.KuikaB2B_ShipmentSalesCustomerMobile !== undefined
        ? stateVars.KuikaB2B_ShipmentSalesCustomerMobile?.length > 0
          ? stateVars.KuikaB2B_ShipmentSalesCustomerMobile[0].totalRows
          : null
        : this.state.KuikaB2B_ShipmentSalesCustomerMobile?.length > 0
        ? this.state.KuikaB2B_ShipmentSalesCustomerMobile[0].totalRows
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ReportsRefferalCustomerComponent_532644_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsRefferalCustomerComponent_373528_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ReportsRefferalCustomer/ReportsRefferalCustomerComponent_373528_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.KuikaB2B_ShipmentSalesCustomerMobile =
        result?.data.kuikaB2B_ShipmentSalesCustomerMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsRefferalCustomerComponent_373528_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsRefferalCustomerComponent_373528_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsRefferalCustomerComponent_373528_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsrefferalcustomer_362270_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.isComp409247Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsRefferalCustomerComponent_373528_onChange2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ReportsRefferalCustomerComponent_373528_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsRefferalCustomerComponent_373528_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsRefferalCustomerComponent_373528_onChange3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsRefferalCustomerComponent_373528_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.dataSource_624937 =
        stateVars.KuikaB2B_ShipmentSalesCustomerMobile ??
        this.state.KuikaB2B_ShipmentSalesCustomerMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsRefferalCustomerComponent_373528_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsRefferalCustomerComponent_373528_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsRefferalCustomerComponent_373528_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.reportsrefferalcustomer_362270_total =
        ReactSystemFunctions.value(
          this,
          stateVars.KuikaB2B_ShipmentSalesCustomerMobile !== undefined
            ? stateVars.KuikaB2B_ShipmentSalesCustomerMobile?.length > 0
              ? stateVars.KuikaB2B_ShipmentSalesCustomerMobile[0].totalRows
              : null
            : this.state.KuikaB2B_ShipmentSalesCustomerMobile?.length > 0
            ? this.state.KuikaB2B_ShipmentSalesCustomerMobile[0].totalRows
            : null
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ReportsRefferalCustomerComponent_518571_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsrefferalcustomer_330953_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsrefferalcustomer_179452_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsRefferalCustomerComponent_595833_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_330953_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_179452_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsRefferalCustomer/ReportsRefferalCustomerComponent_595833_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_ShipmentSalesCustomerMobile =
      result?.data.kuikaB2B_ShipmentSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsRefferalCustomerComponent_595833_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsRefferalCustomerComponent_595833_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsrefferalcustomer_362270_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_ShipmentSalesCustomerMobile ??
      this.state.KuikaB2B_ShipmentSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsRefferalCustomerComponent_110366_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/reportsrefferalcustomerheader") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ReportsRefferalCustomerHeader",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "reportsrefferalcustomer_624937_value",
          "customerCode"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ReportsRefferalCustomer",
      "ReportsRefferalCustomerHeader",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsRefferalCustomerComponent_362270_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_330953_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_179452_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomer_362270_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsRefferalCustomer/ReportsRefferalCustomerComponent_362270_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_ShipmentSalesCustomerMobile =
      result?.data.kuikaB2B_ShipmentSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsRefferalCustomerComponent_362270_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsRefferalCustomerComponent_362270_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_ShipmentSalesCustomerMobile ??
      this.state.KuikaB2B_ShipmentSalesCustomerMobile;
    formVars.reportsrefferalcustomer_362270_total = ReactSystemFunctions.value(
      this,
      stateVars.KuikaB2B_ShipmentSalesCustomerMobile !== undefined
        ? stateVars.KuikaB2B_ShipmentSalesCustomerMobile?.length > 0
          ? stateVars.KuikaB2B_ShipmentSalesCustomerMobile[0].totalRows
          : null
        : this.state.KuikaB2B_ShipmentSalesCustomerMobile?.length > 0
        ? this.state.KuikaB2B_ShipmentSalesCustomerMobile[0].totalRows
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsRefferalCustomerPageInit();
    }
  }
}
